import _ from 'lodash';
import * as types from './action-types';

let interval,
  startedAt;

export function setStatus (string) {
  return {
    type: types.SET_STATUS,
    payload: string
  };
}

export function startTimer (callback) {
  return async (dispatch, getState) => {
    dispatch(setStatus('started'));
    startedAt = new Date();

    const runCallback = async (callback) => {
      await callback(dispatch, getState);

      dispatch(checkTimeout());

      const { timer } = getState();
      if (timer.status === 'started') {
        _.delay(() => {
          runCallback(callback);
        }, timer.delay * 1000);
      }
    };

    runCallback(callback);
  };
}

export function checkTimeout () {
  return (dispatch, getState) => {
    const { timer } = getState();
    let done = ((new Date()) - startedAt)/1000 > timer.timeout;

    if (done) {
      dispatch(stopTimer('timeout'));
    }
  };
}

export function stopTimer (nextStatus='stopped') {
  return (dispatch) => {
    clearTimeout(interval);
    dispatch(setStatus(nextStatus));
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/modules/timer/index.js
 **/